const driverShifts = {
  filters: {
    suppliers: 'Flotten',
  },

  form: {
    information: {
      shiftDetails: {
        fields: {
          suppliers: 'Flotten',
        },
      },
    },
  },
  calendarTable: {
    filters: {
      suppliers: 'Flotten',
    },
  },
};

export default driverShifts;
